import React from "react";
import { Skeleton } from "@mui/material";
import { Box } from "@mui/system";

export const LoadingSkeleton = () => (
  <Box className="_d-grid-sm-gap" px={1}>
    <Skeleton sx={{ width: "80%", borderRadius: "32px" }} />
    <Skeleton sx={{ width: "60%", borderRadius: "32px" }} />
  </Box>
);
